import React from 'react';
import { Route, Switch, useLocation, useHistory } from 'react-router-dom';
import { Navbar, NavbarBrand, Button } from 'reactstrap';
import { Footer } from '~/shared/components/Footer';
import { Goal } from './Goal';
import { Story } from './Story';
import { Photo } from './Photo';
import { Share } from './Share';

export const StartCampaignIndex = () => {
  const location = useLocation();
  const history = useHistory();

  return (
    <div>
      <Navbar
        container
        color='white'
        className='border-bottom border-primary border-2'
      >
        <NavbarBrand href='/login'>
          <div
            className='sidebar__logo'
            style={{ width: '169px', height: '64px' }}
            // to='/login'
          />
        </NavbarBrand>
        <Button
          color='primary'
          size='sm'
          onClick={() => history.push('/dashboard')}
        >
          Save and Return Later
        </Button>
      </Navbar>
      <Switch>
        <Route path='/start-campaign/goal' component={Goal} />
        <Route path='/start-campaign/story' component={Story} />
        <Route path='/start-campaign/photo' component={Photo} />
        <Route path='/start-campaign/share' component={Share} />
      </Switch>
      <Footer />
    </div>
  );
};
